export default "__VITE_ASSET__BvhUuD7B__"